import { TravellerWithCollectionMembershipsDTO } from '@/api/trafikportalen';
import {
  getMembershipStatus,
  type MembershipStatus,
} from '@/helpers/membershipStatus';

export const getTravellerStatus = (
  traveller: TravellerWithCollectionMembershipsDTO,
): MembershipStatus => {
  const statuses = traveller.memberships.map((membership) =>
    getMembershipStatus(membership),
  );

  if (
    statuses.length === 0 ||
    statuses.every((status) => status === 'inactive')
  ) {
    return 'inactive';
  }
  if (statuses.some((status) => status === 'active')) {
    return 'active';
  }
  if (statuses.some((status) => status === 'pending-inactivation')) {
    return 'pending-inactivation';
  }
  if (statuses.some((status) => status === 'will-inactivate')) {
    return 'will-inactivate';
  }

  return 'active';
};
